var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"perfis-info-alert mb-4",attrs:{"color":"primario","outlined":"","dense":"","icon":"fas fa-info-circle"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }